module.exports = __webpack_public_path__ + "img/specific_haunt_button.01f48309.png";